import React from "react";
import ReactDOM from "react-dom/client";
import "./index.scss";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import "bootstrap/dist/css/bootstrap.min.css";
import store, { persistor } from "./store";
import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";
import "react-datepicker/dist/react-datepicker.css";
import "animate.css";
import "react-checkbox-tree/lib/react-checkbox-tree.css";
import "react-quill/dist/quill.snow.css";
import { CircularProgress } from "@mui/material";
import HttpsRedirect from "react-https-redirect";


const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <>
    <Provider store={store}>
      <HttpsRedirect> 
        <PersistGate loading={<div className="loader">
          <CircularProgress sx={{ color: "#86c65a" }} />
        </div>} persistor={persistor}>
          <App />
        </PersistGate>
       </HttpsRedirect>
    </Provider>
  </>
);

// "start": "react-scripts start",(packege.json)
// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
